import { render, staticRenderFns } from "./RoleModal.vue?vue&type=template&id=1f70b128&"
import script from "./RoleModal.vue?vue&type=script&lang=js&"
export * from "./RoleModal.vue?vue&type=script&lang=js&"
import style0 from "./RoleModal.vue?vue&type=style&index=0&id=1f70b128&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports